<template>
  <!--
  - Accepte liste syllabes et bonne réponse en prop
  - Renvoie évènement en cas de réponse correcte.
  -->

  <div style="display: flex; flex-direction: column; justify-content: center;">
    <div id="responseZone" class="smallMargin paddingRound flexwrap centercenter" @dragover.prevent @dragenter.prevent
         @drop="onDrop($event, 'answer')">

      <div v-if="(pass || crudeAnswer === answer) && !sameLanguage"
           class="proposition flexwrap centercenter paddingRound mediumRoundAngles mediumShadow"
           :class="{plainGoldTheme:level>=3, plainSilverTheme:level==2, plainCopperTheme:level==1, plainStandardTheme:level==0, }">
        {{goodAnswer}}
      </div>
      <div v-else-if="(pass || crudeAnswer === answer)"
           class="propositionSyllable flexwrap centercenter paddingRound mediumRoundAngles mediumShadow"
           :class="{plainGoldTheme:level>=3, plainSilverTheme:level==2, plainCopperTheme:level==1, plainStandardTheme:level==0, }">
        {{goodAnswer}} = {{answerTrad}}
      </div>
      <div v-else-if="answer !== this.crudeAnswer && answer !== ''" style="padding-bottom: 0.2vw;">
          <span v-for="(element, num) in syllablesAnswer" :key="num" class="proposition clickable centercenter alignText paddingRound smallRoundAngles mediumShadow" :class="{plainGoldTheme:level>=3, plainSilverTheme:level==2, plainCopperTheme:level==1, plainStandardTheme:level==0, }" draggable="true"
                @dragstart="drag($event, element)"
                @click="changeList(element, 'prop')">
            {{element.value}}
          </span>
      </div>
      <div v-else>
        <span class="textholder" v-if="!isMobile">Déplace ici les syllabes dans le bon ordre</span>
        <span class="textholder" v-else>Clique sur les syllabes dans le bon ordre</span>
      </div>

    </div>

    <div id="syllablesList" class="smallMargin flexwrap" @dragover.prevent @dragenter.prevent
         @drop="onDrop($event, 'prop')">
      <span v-for="(element, num) in syllablesProp" :key="num" class="clickable paddingRound SmallRoundAngles mediumShadow syllable" :class="{plainGoldTheme:level>=3, plainSilverTheme:level==2, plainCopperTheme:level==1, plainStandardTheme:level==0, }" draggable="true"
            @dragstart="drag($event, element)"
            @click="changeList(element, 'answer')">
          {{element.value}}
      </span>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "syllablesAnswer",

  props: {
    syllables: Array,
    goodAnswer: String,
    answerTrad: String,
    sameLanguage: Boolean,
    pass: Boolean
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    ...mapGetters('session', [
      'currentWord'
    ]),

    crudeAnswer: function() {
      return this.goodAnswer.replace(/ /g,"");
    },

    level: function () {
      if (this.currentWord.lemma.user_lemma.length > 0) {
        return this.currentWord.lemma.user_lemma[0].knowledge_level
      }
      return 0
    },

    syllablesAnswer: function() {
      return this.syllables.filter(element => element.list === 'answer').sort(function(a,b) {
        return a.order - b.order
      })
    },

    syllablesProp: function() {
      return this.syllables.filter(element => element.list === 'prop')
    },

    answer: {
      get: function() {
        let answer = '';
        this.syllablesAnswer.forEach(function(element) {
          answer += element.value;
        })
        return answer;
      }

    }
  },

  watch: {
    pass: function() {
      this.$emit('goodAnswer', false)
    }
  },

  methods: {
    drag: function(event, item) {
      event.dataTransfer.dropEffect = 'move'
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('itemID', item.id)
    },

    onDrop: function(event, list) {
      const itemID = event.dataTransfer.getData('itemID')
      const item = this.syllables.find(item => item.id == itemID)
      this.changeList(item, list)
      // si la réponse est juste, on envoie le signal correspondant
      if(this.answer === this.crudeAnswer) {
        this.$emit('goodAnswer', true)
      }
    },

    changeList: function(item, newlist) {
      item.list = newlist
      if(newlist === 'answer') {
        this.syllables.forEach((element, index) => {
          if(element.id === item.id) {
            this.syllables[index].order = this.order;
            this.order++;
          }
        })
      }
      // si la réponse est juste, on envoie le signal correspondant
      if(this.answer === this.crudeAnswer) {
        this.$emit('goodAnswer', true)
      }
    }
  },

  data() {
    return {
      order: 0
    }
  }

}
</script>

<style scoped>
#responseZone {
  width: fit-content;
  min-width: 10vw;
  min-height: 2vw;
  align-content: flex-end;
  border-bottom: 1px solid black;
  margin-bottom: 1vw;
  text-align: center;
}


.syllable {
  margin-right: 0.5vw;
  margin-bottom: 0.5vw;
  font-size: 1.3em;
  text-align: center;
}

#syllablesList {
  max-width: 100%;
  min-width: fit-content;
  height: max-content;
  align-content: flex-start;
  justify-items: center;
  justify-content: center;
  margin-left: 0.5vw;
}

.textholder {
  color: #eeeeee55;
}


.propositionSyllable {
  position: relative;
  font-size: 150%;
  font-weight: bold;
  width: 24vw;
  height: 2.5em;
  text-align: center;
  cursor: pointer;
}

@media screen and (max-device-width: 767px) {

  #responseZone {
    min-width: 40vw;
    min-height: 8vw;
  }
  .syllable {
    margin-right: 3vw;
    margin-bottom: 3vw;
    font-size: 1.6em;
  }

  #syllablesList {
    margin-left: 2vw;
  }

  .propositionSyllable {
    width: 76vw;
    height: 2.5em;
  }
}
</style>